import * as d3 from 'd3'

let globalBudgetIndex;

async function get_index() {
    if (globalBudgetIndex) return globalBudgetIndex;

    let index = await d3.csv('./data/budget_index.csv');

    globalBudgetIndex = new Map(index.map(r => [r.budgetName, r.budgetId]))

    return globalBudgetIndex;
}

export default async function(budgetName) {
    let budget_index = await get_index();
    let budgetId = budget_index.get(budgetName);

    if (!budgetId) throw `budgetName '${budgetName}' is not found`;

    let data = await d3.csv(`./data/budget/${budgetId}.csv`)

    return data;
}